import { render, staticRenderFns } from "./ClientNotesView.vue?vue&type=template&id=25ec5eda&scoped=true"
import script from "./ClientNotesView.vue?vue&type=script&lang=js"
export * from "./ClientNotesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ec5eda",
  null
  
)

export default component.exports